import React from "react";
import Add from "./Add";
import Edit from "./Edit";
import Overview from "./Overview";
import Screen from "../../home/content/Screen";
import { Auth } from "../../../context/admin/Authentication";
import { PositionProvider } from "../../../context/position/PositionContext";
import { DoSeeDataProvider } from "../../../context/doSeeData/DoSeeDataContext";
import { CountryProvider } from "../../../context/country/countryContext/CountryContext";

export const Foods = () => {
  return (
    <DoSeeDataProvider>
      <PositionProvider>
        <Auth
          children={
            <Screen
              component={<Overview />}
              title="Foods"
            />
          }
        />
      </PositionProvider>
    </DoSeeDataProvider>
  );
};

export const AddFood = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Add />}
              title="Add Food"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const EditFood = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Edit />}
              title="Edit Food"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};
